module.exports = __webpack_public_path__ + "static/media/photo_014.116e0771.JPG";